import React, { useState } from 'react';
import { FaFilter } from "react-icons/fa6";
import { MdContentCopy } from "react-icons/md";
import { useSelector } from 'react-redux';
import { GrShare } from "react-icons/gr";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
import { IoFilter } from 'react-icons/io5';
import { FaArrowDown, FaArrowUp, FaLocationArrow } from 'react-icons/fa';


const PartnersTable = () => {
    const PartnersTableData = useSelector(state => state.user.PartnersTableData);
    const UserId = useSelector(state => state.user.UserInputid)
    const navigate = useNavigate()
    console.log("UserIdUserIdUserId",UserId)

    const PartnerData = PartnersTableData?.map(item => {
        const timestamp = item.time;
        const date = new Date(timestamp * 1000);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;

        return {
            Time: formattedDate,
            Address: item.userAddress,
            ID: item.userId,
            Profit_BUSD: item.profitAmount,
            partners: item.partners
        };
    });

    const CopyAddress = (address) => {
        navigator.clipboard.writeText(address)
          .then(() => {
            toast.success('Address copied to clipboard!');
          });
      };


    const NavigateUrl = `https://bscscan.com/address`

    const NavigateUrlFunction = (address) => {
        const Url = `${NavigateUrl}/${address}`;
        window.open(Url, '_blank');
    };


    const [rowsToShow, setRowsToShow] = useState(5);
    const handleShowMore = () => {
        setRowsToShow(prevRowsToShow => prevRowsToShow + 3);
    };

    const handleShowLess = () => {
        setRowsToShow(prevRowsToShow => (prevRowsToShow > 3 ? prevRowsToShow - 3 : 3));
    };

    return (
        <>
            <div className='PartnerTable_MainPage h-screen'>
                <div className='Partners_Label_section'>
                    <div className='Box1  box '>
                        <h1>Partners</h1>
                        <span className='Span_id  Main_GradienTCoilor'>ID {UserId}</span>
                    </div>
                    <div className='Box2 box Main_GradienTCoilor'>
                        <IoFilter size={29} />
                        <p>Filters</p>
                    </div>
                </div>
                <div className='Partners_table_Section'>
                    <table className='Table-data' cellPadding={"20px"}>
                        <thead>
                            <tr className='First_Tr'>
                                <th>Date</th>
                                <th>Address</th>
                                <th>ID</th>
                                <th>Profit BUSD</th>
                                <th>Partners</th>
                            </tr>
                        </thead>
                        <tbody>
                            {PartnerData?.slice(0,rowsToShow)?.map((data, index) => (
                                <tr key={index}>
                                    <td style={{ opacity: "60%" }}>{data.Time}</td>
                                    <td className='Table_Tr_div'>
                                        {`${data.Address?.slice(0, 6) + "..." + data.Address?.slice(-5)}`}<span><MdContentCopy size={20} onClick={() => CopyAddress(data.Address)} className='Copy_btn_Class' /></span><span><FaLocationArrow onClick={() => NavigateUrlFunction(data.Address)}
                                            className='Copy_btn_Class'
                                        /></span></td>
                                    <td><span className='Span_User_id 
                                    Main_GradienTCoilor '>ID {data.ID}</span></td>
                                    <td>{data.Profit_BUSD}</td>
                                    <td>{data.partners}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {
                        PartnerData?.length >=5 &&
                        <div className="Partners_ShowTable" >
                                <p onClick={handleShowLess} className='Main_GradienTCoilor'><FaArrowUp /> <span>Show Less</span></p>
                                <p onClick={handleShowMore} className='Main_GradienTCoilor'><FaArrowDown /> <span>Show more</span></p>
                            </div>
                            
                    }
                    {
                        PartnerData?.length<1 &&  <p className='Dat_Not_found_Partners'>No Data Found</p>
                    }
                    
                </div>
               
            </div>
            <ToastContainer
position="bottom-right"
autoClose={2000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
/>

        </>
    );
};

export default PartnersTable;
